import { AttendanceCode } from '@schooly/api';
import { theme } from '@schooly/style';

export const getAttendanceCodePalette = (code: AttendanceCode) => ({
  primary: code.is_present ? theme.palette.common.green1 : theme.palette.common.wine1,
  secondary: code.is_present ? theme.palette.common.green4 : theme.palette.common.wine5,
});
